import { CompositionConfig } from '../../types/CompositionConfig';
import { CompositeSegment } from '../../types/Segment/CompositeSegment';
import { SegmentType } from '../../types/Segment/Type';
import { VideoSegment } from '../../types/Segment/VideoSegment';
import { CaptionsTrack } from '../../types/Track/CaptionsTrack/CaptionsTrack';
import { SegmentsTrack } from '../../types/Track/SegmentsTrack';
import { TrackType } from '../../types/Track/Type';

export const getSegmentsTrack = (playerConfig: CompositionConfig) => {
  return playerConfig?.playerConfig?.tracks?.find(track => track.type === TrackType.SEGMENTS) as SegmentsTrack;
};

// !! TODO @HiteshChoudhary0098 remove this function cause it will cause confusion with splits. Should return array of composite segments
export const getCompositeSegment = (playerConfig: CompositionConfig) => {
  const trackSegments = getSegmentsTrack(playerConfig);
  const compositeSegment = trackSegments?.segments?.find(
    segment => segment.type === SegmentType.COMPOSITE
  ) as CompositeSegment;

  return compositeSegment;
};

export const getCaptionsTrack = (playerConfig: CompositionConfig | null) => {
  const captionsTrack = playerConfig?.playerConfig?.tracks?.find(track => track.type === TrackType.CAPTIONS) as
    | CaptionsTrack
    | undefined;

  return captionsTrack;
};

export const getVideoSegmentById = (playerConfig: CompositionConfig, id: string): VideoSegment | undefined => {
  const segmentsTrack = getSegmentsTrack(playerConfig);
  return segmentsTrack?.segments?.find(segment => segment.type === SegmentType.VIDEO && segment.id === id) as
    | VideoSegment
    | undefined;
};
